(function () {
  const APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwjUKSgVKVc9CthCojGtWOK-iPhz1GakH4_hW4UV4FX1nc6ftaTXF7kb1_BTrZc_Ykh/exec';

  var STEPS = [
    { id:'identity', type:'identity', label:'Your details' },
    { id:'nhs_number', type:'text', label:'What is your NHS number?', hint:'You can find it here', hintLink:'https://www.nhs.uk/nhs-services/find-nhs-number/', required:true },
    { id:'height', type:'measurement', label:'What is your height?', units:['cm','m','ft_in'], required:true },
    { id:'starting_weight', type:'measurement', label:'What was your starting weight?', units:['kg','st_lb','lb'], required:true },
    { id:'current_weight_photo', type:'file', label:'What is your current weight?', hint:'Please upload a weighing scales photo', required:true },
    { id:'diet_plan', type:'select', label:'Are you following a diet or healthy eating plan?', options:['Yes','No'], required:true },
    { id:'meals', type:'textarea', label:'What does an average day of meals and snacks look like?', hint:'Calories/macros/timing - as much detail as possible', required:true },
    { id:'activity', type:'select', label:'How much physical activity do you do each week?', options:['Less than 30 mins','30-90 mins','90-150 mins','More than 150 mins'], required:true },
    { id:'medication_adherence', type:'select', label:'Are you remembering to take your medication weekly?', options:['Yes','No'], required:true },
    { id:'treatment_gaps', type:'select', label:'Have you had any breaks or gaps in treatment?', options:['Yes','No'], required:true },
    { id:'weight_summary', type:'calculated', label:'Your progress' },
    { id:'side_effects', type:'textarea', label:'Have you experienced any side effects or tolerability issues (e.g. nausea, constipation, fatigue)? Please describe.', required:true },
    { id:'medication_effectiveness', type:'select', label:'Do you feel the medication is still reducing hunger, cravings, or food noise?', options:['Yes','No','Not sure'], required:true },
    { id:'mood', type:'select', label:'Have you noticed improvements in confidence, mood, or emotional eating habits?', options:['Yes','No','Somewhat'], required:true },
    { id:'tracking', type:'select', label:'Are you tracking your weight, food, or activity in our app or another tool?', options:['Yes, using our app','Yes, using another tool','No'], required:true },
    { id:'plateau', type:'select', label:'Have you hit a plateau in your weight loss journey?', hint:'More than 2 weeks of no change', options:['Yes','No'], required:true },
    { id:'next_goal', type:'select', label:'What\'s your next goal?', options:['Continue losing weight','Transition to maintenance','Consider medicine-free'], required:true },
    { id:'comments', type:'textarea', label:'Do you have any additional comments or feedback about your experience with the programme?', required:false, isLast:true }
  ];

  var state = { step:-1, answers:{}, customerId:null, customerVerified:false };
  var body = document.getElementById('rq-body');
  var progressFill = document.getElementById('rq-progress-fill');
  var shopDomain = document.getElementById('review-quiz').dataset.shop;

  function toCm(value, unit){
    if(unit==='cm') return parseFloat(value);
    if(unit==='m') return parseFloat(value)*100;
    if(unit==='ft_in'){
      var parts = String(value).split(/['\s]+/).filter(Boolean);
      var ft = parseFloat(parts[0]||0), inch = parseFloat(parts[1]||0);
      return (ft*30.48)+(inch*2.54);
    }
    return parseFloat(value);
  }

  function toKg(value, unit){
    if(unit==='kg') return parseFloat(value);
    if(unit==='lb') return parseFloat(value)*0.453592;
    if(unit==='st_lb'){
      var parts = String(value).split(/[\s]+/).filter(Boolean);
      var st = parseFloat(parts[0]||0), lb = parseFloat(parts[1]||0);
      return (st*6.35029)+(lb*0.453592);
    }
    return parseFloat(value);
  }

  function calcBmi(heightCm, weightKg){
    var m = heightCm/100;
    return weightKg/(m*m);
  }

 function setProgress(pct){
  progressFill.style.background = 'linear-gradient(to right, #000000 '+pct+'%, #e5e0eb '+pct+'%)';
}
  function render(){
    if(state.step === -1){
      setProgress(0);
      body.innerHTML = renderIntro();
      body.scrollTop = 0;
      bindIntro();
      return;
    }
    var step = STEPS[state.step];
    setProgress(((state.step+1)/STEPS.length)*100);
    body.innerHTML = renderStep(step);
    body.scrollTop = 0;
    bindStep(step);
  }

  function renderIntro(){
    return '<div class="rq-intro">'+
      '<h2>You\'ve now reached your 6-month milestone on the programme &ndash; congratulations!</h2>'+
      '<p>As part of our clinical responsibility, we need to carry out a 6-month review</p>'+
      '<button class="rq-btn" id="rq-start">Start</button>'+
      '<div class="rq-intro-time">&#9200; Takes 5 minutes</div>'+
      '</div>';
  }

  function bindIntro(){
    document.getElementById('rq-start').addEventListener('click', function(){
      state.step = 0;
      render();
    });
  }

  document.documentElement.classList.add('rq-locked');

  function renderStep(step){
    var badge = '<div class="rq-question"><span class="rq-step-badge">'+(state.step+1)+'</span><span>'+step.label+'</span></div>';
    var hintText = step.hint ? step.hint : '';
    if(step.hintLink){ hintText += ' <a href="'+step.hintLink+'" target="_blank" rel="noopener">'+step.hintLink+'</a>'; }
    var hint = hintText ? '<p class="rq-hint">'+hintText+'</p>' : '<p class="rq-hint" style="visibility:hidden">.</p>';
    var field = '';

    if(step.type==='identity'){
      field = '<div class="rq-field">'+
        '<label>First name</label><input class="rq-input" id="rq-first" placeholder="Jane"><br><br>'+
        '<label>Last name</label><input class="rq-input" id="rq-last" placeholder="Smith"><br><br>'+
        '<label>Email</label><input class="rq-input" id="rq-email" type="email" placeholder="name@example.com">'+
        '<div class="rq-error" id="rq-error" style="display:none"></div>'+
        '</div>';
    } else if(step.type==='text'){
      field = '<div class="rq-field"><input class="rq-input" id="rq-answer" placeholder="Type your answer here...">'+
        '<div class="rq-error" id="rq-error" style="display:none"></div></div>';
    } else if(step.type==='textarea'){
      field = '<div class="rq-field"><textarea class="rq-textarea" id="rq-answer" placeholder="Type your answer here..."></textarea>'+
        '<div class="rq-error" id="rq-error" style="display:none"></div></div>';
    } else if(step.type==='measurement'){
      var unitOptions = step.units.map(function(u){
        var labels={cm:'Cm',m:'Metres',ft_in:'Feet+Inches',kg:'Kg',st_lb:'St+Lbs',lb:'Lbs'};
        return '<option value="'+u+'">'+labels[u]+'</option>';
      }).join('');
      field = '<div class="rq-field"><div class="rq-row">'+
        '<input class="rq-input" id="rq-answer" type="text" inputmode="decimal" autocomplete="off" placeholder="e.g. 175">'+
        '<select class="rq-select" id="rq-unit">'+unitOptions+'</select>'+
        '</div><div class="rq-error" id="rq-error" style="display:none"></div></div>';
    } else if(step.type==='select'){
      var opts = step.options.map(function(o,i){
        return '<div class="rq-option" data-value="'+o+'"><span class="rq-option-key">'+String.fromCharCode(65+i)+'</span><span>'+o+'</span></div>';
      }).join('');
      field = '<div class="rq-field"><div class="rq-options" id="rq-options">'+opts+'</div>'+
        '<div class="rq-error" id="rq-error" style="display:none"></div></div>';
    } else if(step.type==='file'){
      field = '<div class="rq-field"><label class="rq-upload" id="rq-upload-zone">'+
        '<div>Choose file or drag here</div><div class="rq-upload-hint">Size limit: 10MB</div>'+
        '<input type="file" id="rq-file" accept="image/*"></label>'+
       '<div id="rq-file-name" style="margin-top:8px;color:#000000"></div>'+
        '<div class="rq-error" id="rq-error" style="display:none"></div></div>';
    } else if(step.type==='calculated'){
      var heightCm = toCm(state.answers.height, state.answers.height_unit);
      var startKg = toKg(state.answers.starting_weight, state.answers.starting_weight_unit);
      var currentKg = state.answers.current_weight_kg || startKg;
      var bmi = calcBmi(heightCm, currentKg);
      var lostKg = startKg - currentKg;
      var pct = startKg ? (lostKg/startKg)*100 : 0;
      var pass = pct >= 5;
      state.answers.bmi = bmi.toFixed(1);
      state.answers.weight_lost_kg = lostKg.toFixed(1);
      state.answers.weight_lost_pct = pct.toFixed(1);
      state.answers.goal_met = pass;
      field = '<div class="rq-field"><div class="rq-calc">'+
        'BMI: <strong>'+bmi.toFixed(1)+'</strong><br>'+
        'Weight lost: <strong>'+lostKg.toFixed(1)+' kg ('+pct.toFixed(1)+'%)</strong><br>'+
        '5% goal: <span class="'+(pass?'rq-calc-pass':'rq-calc-fail')+'">'+(pass?'Met &#10003;':'Not yet met &#10007;')+'</span>'+
        '</div></div>';
    }

    var btnLabel = step.isLast ? 'Submit' : 'OK';
    var actions = '<div class="rq-actions"><button class="rq-btn" id="rq-next">'+btnLabel+'</button></div>';
    var nav = '<div class="rq-nav"><button class="rq-nav-btn" id="rq-nav-up"'+(state.step===0?' disabled':'')+'>&#8593;</button><button class="rq-nav-btn" id="rq-nav-down">&#8595;</button></div>';
    return badge+hint+field+actions+nav;
  }

  function goBack(){
    if(state.step>0){ state.step--; render(); }
  }

  function bindStep(step){
    var nextBtn = document.getElementById('rq-next');
    var optionEls = document.querySelectorAll('.rq-option');
    optionEls.forEach(function(el){
      el.addEventListener('click', function(){
        optionEls.forEach(function(o){ o.classList.remove('selected'); });
        el.classList.add('selected');
        el.dataset.selected = 'true';
      });
    });

    var uploadZone = document.getElementById('rq-upload-zone');
    if(uploadZone){
      document.getElementById('rq-file').addEventListener('change', function(e){
        var file = e.target.files[0];
        if(file){ document.getElementById('rq-file-name').textContent = file.name; }
      });
    }

    nextBtn.addEventListener('click', function(){
      handleNext(step);
    });

    document.getElementById('rq-nav-up').addEventListener('click', goBack);
    document.getElementById('rq-nav-down').addEventListener('click', function(){
      handleNext(step);
    });
  }

  function showError(msg){
    var el = document.getElementById('rq-error');
    el.textContent = msg;
    el.style.display = 'block';
  }

  function setButtonLoading(btn, loading) {
    btn.disabled = loading;
    btn.textContent = loading ? 'Checking...' : 'OK';
  }

  function handleNext(step){
    if(step.type==='identity'){
      var email = document.getElementById('rq-email').value.trim().toLowerCase();
      var first = document.getElementById('rq-first').value.trim();
      var last = document.getElementById('rq-last').value.trim();

      if(!email){ showError('Please enter your email'); return; }

      state.answers.email = email;
      state.answers.first_name = first;
      state.answers.last_name = last;

      var nextBtn = document.getElementById('rq-next');
      setButtonLoading(nextBtn, true);
      showError('');

      fetch(APPS_SCRIPT_URL, {
        method:'POST',
        headers:{'Content-Type':'text/plain'},
        body: JSON.stringify({
          action:'checkCustomer',
          email: email,
          shop: shopDomain
        })
      })
      .then(parseJsonSafe)
      .then(function(lookup){
        setButtonLoading(nextBtn, false);
        if(!lookup.found){
          showError('No customer found – please enter the email you used with XO.');
          return;
        }
        state.customerId = lookup.customerId;
        state.customerVerified = true;
        advance();
      })
      .catch(function(err){
        setButtonLoading(nextBtn, false);
        showError('Something went wrong while checking your email. Please try again.');
        console.error('Email check failed:', err);
      });
      return;
    }

if(step.type==='text' || step.type==='textarea'){
      var val = document.getElementById('rq-answer').value.trim();
      if(step.required && !val){ showError('Please fill in '+step.label); return; }
      state.answers[step.id] = val;
      if(step.isLast){ submitQuiz(); } else { advance(); }
      return;
    }

    if(step.type==='measurement'){
      var val2 = document.getElementById('rq-answer').value.trim();
      var unit = document.getElementById('rq-unit').value;
      if(step.required && !val2){ showError('Please fill in '+step.label); return; }
      state.answers[step.id] = val2;
      state.answers[step.id+'_unit'] = unit;
      if(step.id==='height'){ state.answers.height_cm = toCm(val2, unit).toFixed(1); }
      if(step.id==='starting_weight'){ state.answers.starting_weight_kg = toKg(val2, unit).toFixed(1); }
      advance();
      return;
    }

    if(step.type==='select'){
      var selected = document.querySelector('.rq-option.selected');
      if(!selected){ showError('Please select an option'); return; }
      state.answers[step.id] = selected.dataset.value;
      advance();
      return;
    }

    if(step.type==='file'){
      var fileInput = document.getElementById('rq-file');
      var file = fileInput.files[0];
      if(step.required && !file){ showError('Please upload a photo'); return; }
      if(file){
        var reader = new FileReader();
        reader.onload = function(){
          state.answers.current_weight_photo_base64 = reader.result;
          state.answers.current_weight_photo_name = file.name;
          promptCurrentWeight();
        };
        reader.readAsDataURL(file);
      } else {
        advance();
      }
      return;
    }

    if(step.type==='calculated'){
      advance();
      return;
    }

    if(step.isLast){
      submitQuiz();
      return;
    }

    advance();
  }

  function promptCurrentWeight(){
    var kg = prompt('Enter current weight in kg (used to calculate progress):');
    state.answers.current_weight_kg = parseFloat(kg)||0;
    advance();
  }

  function advance(){
    state.step++;
    if(state.step >= STEPS.length){
      showThankYou();
    } else {
      render();
    }
  }

  function parseJsonSafe(response){
    return response.text().then(function(text){
      console.log('[review-quiz] raw response:', text);
      try {
        return JSON.parse(text);
      } catch(e){
        throw new Error('Server did not return JSON. Raw response: ' + text.slice(0,300));
      }
    });
  }

  function submitQuiz(){
    var comments = document.getElementById('rq-answer');
    state.answers.comments = comments ? comments.value.trim() : '';
    var nextBtn = document.getElementById('rq-next');
    nextBtn.disabled = true;
    nextBtn.textContent = 'Submitting...';

    console.log('[review-quiz] Submitting quiz for customerId:', state.customerId);

    fetch(APPS_SCRIPT_URL, {
      method:'POST',
      headers:{'Content-Type':'text/plain'},
      body: JSON.stringify({
        action:'submitQuiz',
        customerId: state.customerId,
        shop: shopDomain,
        answers: state.answers
      })
    })
    .then(function(r){
      console.log('[review-quiz] submitQuiz HTTP status:', r.status);
      return parseJsonSafe(r);
    })
 .then(function(result){
      console.log('[review-quiz] submitQuiz result:', result);
      if(result && result.ok === false){
        throw new Error(result.error || 'Backend reported failure');
      }
      showThankYou();
    })
    .catch(function(err){
      console.error('[review-quiz] Submit failed:', err);
      nextBtn.disabled = false;
      nextBtn.textContent = 'Submit';
      showError('Something went wrong, please try again.\n' + (err && err.message ? err.message : ''));
    });
  }

  function showThankYou(){
    setProgress(100);
    body.innerHTML = '<div class="rq-thankyou"><h2>Thank you for completing your 6-month review.</h2>'+
      '<p>Your answers help us provide you with the most personalised care possible.</p></div>';
  }

  render();
})();